import { RiCalendarLine } from 'react-icons/ri';

import IntegrationIcon from '@assets/buttons-icons/integrations.svg?react';
import palette from '@lib/core/src/theme/palette';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import CachedIcon from '@mui/icons-material/Cached';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import SearchIcon from '@mui/icons-material/Search';
import TelegramIcon from '@mui/icons-material/Telegram';

export type AgentConfigType = {
  agentId: number;
  agentName: string;
  agentDescription: string;
  activeKey: string;
  dataSources: {
    name: string;
    icon: React.ReactNode;
  }[];
  agentProcess: {
    title: string;
    description: string;
    startIcon: React.ReactNode;
    endIcon?: React.ReactNode;
  }[];
};

export const oldAgentsKeys = ['meetingSummary', 'taskFollowUp'];

export const AgentsListConfig: AgentConfigType[] = [
  {
    agentId: 0,
    activeKey: 'meetingSummary',
    agentName: 'Smart template Agent',
    agentDescription:
      'This agent will analyze the transcript and create a summary tailored to your specifications, utilizing recognized tags for precision.',
    dataSources: [
      {
        name: 'Calendar',
        icon: <RiCalendarLine fontSize="16px" />
      }
    ],
    agentProcess: [
      {
        title: 'Auto-Assigns Template Based on Meeting Title',
        description:
          'The AI detects key words in the meeting title and automatically assigns a relevant summary template.',
        startIcon: <CachedIcon fontSize="small" />
      },
      {
        title: 'Analyzes the Meeting Transcript',
        description:
          'Processes the conversation, recognizing important topics and extracting key insights.',
        startIcon: <SearchIcon fontSize="small" />
      },
      {
        title: 'Generates a Structured Summary',
        description:
          'Creates a well-organized summary based on the assigned template, ensuring clarity and consistency.',
        startIcon: <IntegrationIcon fontSize="20px" color={palette.grey[500]} />,
        endIcon: <RiCalendarLine fontSize="16px" />
      }
    ]
  },
  {
    agentId: 2,
    activeKey: 'taskFollowUp',
    agentName: 'Delegation Follow-up Agent',
    agentDescription:
      'The agent will scan your delegated tasks without responses and suggest a follow-up draft.',
    dataSources: [
      {
        name: 'Email',
        icon: <MailOutlinedIcon fontSize="small" />
      }
    ],
    agentProcess: [
      {
        title: 'Monitors Your Communications',
        description:
          'The agent reviews emails and other connected tools to detect when you’ve assigned tasks to someone.',
        startIcon: <IntegrationIcon fontSize="20px" color={palette.grey[500]} />
      },
      {
        title: 'Drafts Follow-Up Messages',
        description:
          'Based on your settings, the agent creates a follow-up draft tailored to the person, task, and timing.',
        startIcon: <BorderColorOutlinedIcon fontSize="small" />
      },
      {
        title: 'You Review & Send',
        description: 'Approve, edit, or dismiss AI suggestions before they are sent.',
        startIcon: <TelegramIcon fontSize="small" />
      }
    ]
  }
];
